import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/Layout/AdminLayout'; 
import error404Image from './error404.png';
import './styles.scss';

const Error404 = () => {
  const navigate = useNavigate();

  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    navigate('/dashboard');
  };
  return (
    <AdminLayout>
      <div className="error404-content-wrapper">
        {/* Error Message */}
        <div className="error-message-section">
          <h1 className="error-title">Oops, 404 Error</h1>
          <p className="error-subtitle">We're working on it.</p>
        </div>

        {/* Action Button */}
        <div className="error-action-section">
          <button className="reload-button" onClick={handleReload}>
            Reload
          </button>
          <button className="home-button" onClick={handleGoHome}>
            Go to Dashboard
          </button>
        </div>

        {/* Error Image - Under buttons */}
        <div className="error-image-container">
          <img 
            src={error404Image} 
            alt="404 Error" 
            className="error-image"
          />
        </div>
      </div>
    </AdminLayout>
  );
};

export default Error404;